module.exports = __webpack_public_path__ + "img/logo22.e2315a36.png";